import React from "react";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen bg-slate-900 text-white overflow-hidden">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black/60 z-10"></div>

      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://images.unsplash.com/photo-1504608524841-42fe6f032b4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80)`,
        }}
      ></div>

      {/* Navigation */}
      <nav className="relative z-20 flex justify-between items-center p-6">
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-orange-500 rounded-full"></div>
          <span className="text-xl">Luma</span>
        </div>
        <div className="flex items-center space-x-4">
          {/* <button className="text-white/80 hover:text-white">Sign in</button> */}
          {/* <button className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-full transition-colors">
            Request a Trial
          </button> */}
          <a
            href="mailto:yourname@example.com?subject=Request%20for%20Demo&body=Hi,%20I%20would%20like%20to%20request%20a%20demo%20or%20trial%20of%20your%20flood%20forecast%20system."
            className="inline-block"
          >
            <button className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-full transition-colors">
              Get in touch
            </button>
          </a>
        </div>
      </nav>

      {/* Main content */}
      <div className="relative z-20 flex flex-col items-center justify-center min-h-[80vh] px-6">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl mb-6 leading-tight">
            Make informed decisions with an
            <br />
            advanced flood dashboard
          </h1>

          <p className="text-xl mb-12 text-white/80">
            Stay ahead of the flood — across all your locations:
          </p>

          {/* Feature tags */}
          {/* <div className="flex flex-wrap justify-center gap-4 mb-12">
            {[
              "Precise flood monitoring",
              "Accurate damage assessment",
              "Context aware AI assistant",
            ].map((feature, index) => (
              <span
                key={index}
                className="px-4 py-2 border border-white/30 rounded-full text-sm bg-white/10 backdrop-blur-sm"
              >
                {feature}
              </span>
            ))}
          </div> */}
          {/* Feature tags */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {[
              { label: "Precise flood monitoring", href: "#dashboard-section" },
              { label: "Accurate damage assessment", href: "#map-section" },
              { label: "Context aware AI assistant", href: "#chat-section" },
            ].map((feature, index) => (
              <a
                key={index}
                href={feature.href}
                className="px-4 py-2 border border-white/30 rounded-full text-sm bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-colors duration-200"
              >
                {feature.label}
              </a>
            ))}
          </div>


          {/* <button className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-full text-lg transition-colors">
            Request Demo
          </button> */}
          <a id="req-demo"
              href="mailto:yourname@example.com?subject=Request%20for%20Demo&body=Hi,%20I%20would%20like%20to%20request%20a%20demo%20of%20your%20flood%20forecast%20system."
              className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-full text-lg transition-colors"
            >
              Request Demo 
          </a>
        </div>
      </div>
    </section>
  );
}
